import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'src/app/services/loader.service';
import { AuthenticationStore } from 'src/app/stores/authentication.store';
import { CartDetail, CheckoutStore } from 'src/app/stores/checkout.store';
import { Product } from 'src/app/stores/product.store';
import { currencyCode, imageUrl } from 'src/environments/environment';
import { AddToCartComponent } from '../add-to-cart/add-to-cart.component';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-related-product',
  templateUrl: './related-product.component.html',
  styleUrls: ['./related-product.component.scss'],
})
export class RelatedProductComponent implements OnInit {
  @Input() productList: Array<Product> = [];
  currencyCode = currencyCode;
  imageUrl = imageUrl;
  constructor(
    private checkOutStore: CheckoutStore,
    private route: Router,
    public userAuth: AuthenticationStore,
    private translate: TranslateService,
    private loaderService: LoaderService,
    private modalCtrl: ModalController
  ) {}

  ngOnInit() {}

  // percentage off the original price, for the card badge
  discount(item): number {
    const actual = Number(item?.actual_price);
    const price = Number(item?.product_price);
    if (!actual || !price || price >= actual) return 0;
    return Math.round((1 - price / actual) * 100);
  }

  product_page(item) {
    this.route.navigate([`/product/${item.slug}`]);
  }

  async addToCart(type: number, productDetails, productDetailId, event) {
    event?.stopPropagation();
    if (this.userAuth.userInfo) {
      this.loaderService.showLoading();
      if (this.checkOutStore?.cartData?.cart?.length > 0) {
        var productQty = [];
        var allItems = [];
        this.checkOutStore?.cartData.cart?.filter(function (element) {
          allItems = allItems.concat(element.items);
        });
        if (productDetails.product_variations?.length > 0) {
          if (
            Object.keys(
              productDetails.product_variations[0].variant[0].variation_fields
            ).length > 0
          ) {
            productQty = allItems?.filter(
              (x) =>
                x.option_data ==
                productDetails.product_variations[0].variant[0]
                  .variation_fields[0].id
            );
          }
        }
        if (!productQty) {
          productQty = allItems?.filter((x) => x.product_id == productDetailId);
        }
        this.checkOutStore.cartData.cart = [];
      }
      try {
        var resp = await this.checkOutStore.postCartAddUpdate({
          cart_id: null,
          product_id: productDetailId,
          qty: productQty?.length > 0 ? productQty[0].qty : 1,
          product_variation:
            productDetails.product_variations?.length > 0 &&
            Object.keys(
              productDetails.product_variations[0].variant[0].variation_fields
            ).length > 0
              ? [
                  {
                    id: productDetails.product_variations[0].variant[0]
                      .variation_fields[0].product_variation_id,
                    variation_fields: [
                      {
                        id: productDetails.product_variations[0].variant[0]
                          .variation_fields[0].id,
                      },
                    ],
                  },
                ]
              : [],
        });
        this.checkOutStore.cartData.cart = resp.data.cart;
        if (type == 1) {
          this.checkOutStore.cartData.cart.forEach((cart, i) => {
            setTimeout(() => {
              var productId = [];
              productId = cart.items.filter(
                (x) => x?.product_id == productDetailId
              );
              if (
                productDetails?.data?.product?.product_variations?.length > 0
              ) {
                productId = cart.items.filter(
                  (x) =>
                    x.option_data ==
                    productDetails.product_variations[0].variant[0]
                      .variation_fields.id
                );
              }
              if (productId.length > 0) {
                productId[0].selected = productId[0].selected ? false : true;
                var items = cart.items.filter((item) => item.selected);
                if (items.length > 0) {
                  this.route.navigate(['/my-product-bag/order-review']);
                }
              }
            }, 100);
          });
        } else {
          const modal = await this.modalCtrl.create({
            component: AddToCartComponent,
            cssClass: 'addToCartModel',
            backdropDismiss: true,
            componentProps: {
              productDetail: resp.data.cart,
              productId: productDetailId,
              selectedItems:
                productDetails.product_variations &&
                productDetails.product_variations[0]?.variant[0]
                  ?.variation_fields?.id,
            },
          });
          modal.present();
        }
        this.loaderService.dismissLoading();
      } catch (error) {
        this.loaderService.presentToast(
          error && error.error && error.error.data
            ? error.error.data
            : this.translate.instant('RATE_ORDER.SOMETHING_WRONG'),
          'middle',
          'danger',
          2000
        );
        setTimeout(() => {
          this.loaderService.dismissLoading();
        }, 2000);
      }
    } else {
      // if (this.platform.is('mobile')) {
      //   const navigationExtras: NavigationExtras = {
      //     state: {
      //       addToCart: true,
      //     },
      //   };
      //   this.router.navigate(['/login-page'], navigationExtras);
      // } else {
      //   const modal = await this.modalCtrl.create({
      //     component: LoginPagePage,
      //     backdropDismiss: true,
      //     componentProps: {
      //       addToCartWeb: true,
      //     },
      //   });
      //   modal.present();
      //   await modal.onDidDismiss();
      // }
    }
  }
}
